import { render, staticRenderFns } from "./DriblabIcon.vue?vue&type=template&id=48321b72"
import script from "./DriblabIcon.vue?vue&type=script&lang=js"
export * from "./DriblabIcon.vue?vue&type=script&lang=js"
import "./DriblabIcon.vue?vue&type=style&index=0&id=48321b72&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports